import { render, staticRenderFns } from "./UserProfileBanner.vue?vue&type=template&id=9d1e4574&"
import script from "./UserProfileBanner.vue?vue&type=script&lang=js&"
export * from "./UserProfileBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports